function r(r){try{for(let o=r;o>0;o--){var n;if(null===(n=ApplePaySession)||void 0===n?void 0:n.supportsVersion(o))return o}}catch(r){console.warn(r)}return null}export{r as resolveSupportedVersion};
